import { ALL_TRACKING_PARAMETERS } from '@nwwp/utils'
import { isClientSide } from './is-client-side'

export function getTrackingParams(): Record<string, string> {
  if (!isClientSide()) return {}
  const params = new URLSearchParams(window.location.search)
  const tracking: Record<string, string> = {}
  ALL_TRACKING_PARAMETERS.forEach((key) => {
    const value = params.get(key)
    if (value) tracking[key] = value
  })
  return tracking
}
